import { createFeatureSelector, createSelector } from '@ngrx/store';
import { featureKey } from '../../store/shared.reducers';
import { MemberPortalSharedState } from '../../store/shared.states';
import { IAccessYourSuperStartComponentState } from './state';

export const memberPortalState = createFeatureSelector<MemberPortalSharedState>(featureKey);

export const getAccessYourSuperStartState = createSelector(memberPortalState, (state) => state.accessYourSuperStartComponentState);

export const accessYourSuperStart_Model = createSelector(
    getAccessYourSuperStartState,
    (state: IAccessYourSuperStartComponentState) => state.model
);
  
export const accessYourSuperStart_Filter = createSelector(
    getAccessYourSuperStartState,
    (state: IAccessYourSuperStartComponentState) => state.filter
  );
  